































































































import { Component, Vue, Ref } from 'vue-property-decorator';
import CouponItem from '@tencent/wphk-components-wecoupon/components/coupon-item/index.vue';
import PageNav from '@/components/we-coupons/page-nav/index.vue';
import { PageResult } from '@/components/we-coupons/page-nav/business';
import { CouponInfo } from '@tencent/wphk-components-wecoupon';
import ContentLoadFail from '@/components/we-coupons/content-load-fail/index.vue';
import { dataLoadCompleteHelper, initShare } from './utils/view-helper';
import { handleGetCouponAction, HandleSubScribeRes, NotifyActionRet } from '@/business/we-coupons/coupon-subscribe';
import { getListBySpKey } from '@/business/we-coupons/coupon';
import WxSubscribeDialog from '@/components/we-coupons/subscribe/wx-subscribe-dialog.vue';
import SearchCom from '@/components/search/index.vue';
import { getKeyStorage, setKeyStorage, clearKeyStorage } from '@/business/we-coupons/coupon-search';
import MerchantItemInfo from '@/components/we-coupons/merchant-item-info.vue';
import { handleCouponShareSetInfo, handleCouponShareShowDialog } from '@tencent/wphk-components-wecoupon/components/share-channel';
import ShareDialog from '@tencent/wphk-components-wecoupon/components/share-channel/share-dialog.vue';
import { ERouteName } from '@/config/index';
import UseGuide  from '@tencent/wphk-components-wecoupon/components/guide/index.vue';

@Component({
  components: {
    CouponItem,
    PageNav,
    ContentLoadFail,
    WxSubscribeDialog,
    SearchCom,
    MerchantItemInfo,
    ShareDialog,
    UseGuide,

  },
})
export default class WeCouponsCouponSearch extends Vue {
  @Ref('pageNav') pageNav!: PageNav<CouponInfo>;
  @Ref('useGuide') useGuide!: typeof UseGuide;
  /** 订阅弹窗 */
  @Ref('wxSubscribeDialog') wxSubscribeDialog!: WxSubscribeDialog;

  /** 订阅模板 id */
  unSubscribeTmpIds: string[] = [];
  /** 订阅弹窗提示内容 */
  subscribeTipContent = '';
  /** 是否加载完成 */
  isComplete = false;

  /** 关键字 */
  key = '';
  /** 是否需要更新 */
  isChange = false;

  /**
   * 是否有下一页
   */
  get hasNext() {
    return true;
  }

  created() {
    this.key = getKeyStorage();

    // 初始化分享（允许分享）
    initShare();
  }

  handleSearch(str: string) {
    console.log('str', str);
    this.handleKeyChange(str);
  }

  handleKeyChange(newKey: string) {
    if (newKey !== this.key) {
      this.isChange = true;
      this.key = newKey;
      setKeyStorage(this.key);
      // 重新渲染分页查询器
      this.$nextTick(() => {
        this.isChange = false;
      });
    }
  }

  clearKey() {
    this.key = '';
    clearKeyStorage();
  }

  backIndex() {
    clearKeyStorage();
    this.$router.replace({
      name: ERouteName.homeWeCouponsList,
    });
  }

  /**
   *  提供查询分页数据方法，供分页组件使用
   */
  async queryCounponList(
    offset: number,
    limit: number,
  ): Promise<PageResult<CouponInfo>> {
    const ret = await getListBySpKey(this.key, offset, limit);
    return ret;
  }

  /**
   * 提供比较2个券数据是否相同的方法，供分页组件过滤重复数据
   */
  compareCouponData(couponA: CouponInfo, couponB: CouponInfo) {
    return couponA.couponId === couponB.couponId;
  }

  /**
   * 将数据分2列展示，以实现瀑布流方式(目前纯css没有更好的实现方式)
   */
  groupList(list: CouponInfo[]) {
    const result: CouponInfo[][] = [[], []];
    // 将广告位插入券列表

    list.forEach((item, i) => {
      result[i % 2].push(item);
    });
    return result;
  }

  /**
   * 当前分类数据加载完毕后通知父页面
   */
  handlePageComplete() {
    dataLoadCompleteHelper.notify(this);
    this.isComplete = true;
  }

  /**
   * 显示订阅弹窗
   */
  async showSubscribeDialog(result: NotifyActionRet) {
    if (result.name === 'closeCouponDetail') {
      initShare(); // 目前设置的是Channel页分享，这里重置回抢券有so的分享
      return;
    }
    // 处理领券接口
    const isShowSubscribeDialog = await handleGetCouponAction(result, (unSubscribeTmpIds, subscribeTipContent) => {
      this.unSubscribeTmpIds = unSubscribeTmpIds || [];
      this.subscribeTipContent = subscribeTipContent || '';
      (this.$refs.wxSubscribeDialog as WxSubscribeDialog)?.showDialog();
    });
    /** 如果是订阅弹窗不展示（展示过了）就播放教程动画
     * 订阅弹窗要展示的话已经在上面的handleGetCouponAction第二个参数回调函数处理了
     */
    if (isShowSubscribeDialog === HandleSubScribeRes.hideSubscribeDialog) {
      this.playUserGuideAnimation();
    }
  }

  playUserGuideAnimation() {
    (this.$refs.useGuide as any).playAnimation();
  }
  onHideSubscribeDialog() {
    this.playUserGuideAnimation();
  }
  /**
   * 点击coupon-item（会拉起券详情弹层）
   */
  handleItemClick(item: CouponInfo) {
    const { couponId, couponName } = item;
    const { spId, spLogo, spName } = item.merchantInfo;
    handleCouponShareSetInfo({
      couponName,
      couponId,
      spId,
      spLogo,
      spName,

      adtagPrefix: 'search',
    });
  }
  /**
   * 拉起分享弹框（券分享，区别于商户分享）
   */
  handleDetailShareClick() {
    handleCouponShareShowDialog();
  }
}
